import { safeDefine } from "../../registration/safe-define.js";
import { AlertDialogElement } from "../../ui/alert-dialog/element.js";
//#region src/define/ui/alert-dialog.ts
safeDefine(AlertDialogElement);
//#endregion

//# sourceMappingURL=alert-dialog.js.map